<h2 class="m-b-5" mat-dialog-title>Cambiar Hora</h2>
<div mat-dialog-content id="baja-edit-card">
  <form class="add-document-form" [formGroup]="timeFormGroup" role="form" autocomplete="off">
    <div>
      <input formControlName="tareaId" type="hidden">
      <mat-form-field  floatLabel="always">
        <input matInput type="time" placeholder="Hora" formControlName="hora">
        <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
      </mat-form-field>

    </div>
  </form>
</div>
<mat-progress-bar class="m-t-5" mode="indeterminate" *ngIf="IsSaving"></mat-progress-bar>
<div class="p-t-5">
  <button class="m-r-15" mat-raised-button color="accent" (click)="addTime()">Guardar</button>
  <button mat-raised-button color="warn" (click)="cancel()">Cancelar</button>
</div>